import {lazy} from 'react';
import {Navigate, type RouteObject} from 'react-router-dom';

import AppInitializerGuard from '@/components/system/common/AppInitializerGuard';

const MobileMapLayout = lazy(() => import('@/pages/map/mobile/Map'));
const MobileSearchLayout = lazy(() => import('@/pages/map/mobile/Search'));
const MobileLandInfoLayout = lazy(() => import('@/pages/map/mobile/LandInfo'));
const MobileLifeContentsLayout = lazy(() => import('@/pages/map/mobile/Life'));
const MobileCultureContentsLayout = lazy(() => import('@/pages/map/mobile/Culture'));
const MobileSafeContentsLayout = lazy(() => import('@/pages/map/mobile/Safe'));
const MobileWantedLayout = lazy(() => import('@/pages/map/mobile/Wanted'));
const MobileAirmapSliderLayout = lazy(() => import('@/pages/map/mobile/AirmapSlider'));
const MobileCampaignMap = lazy(() => import('@/pages/map/mobile/CampaignMap'));
const MobileConstructionNotification = lazy(() => import('@/pages/map/mobile/ConstructionNotification'));
const MobileStatisticMap = lazy(() => import('@/pages/map/mobile/StatisticMap'));
const MobileMapDownloadLayout = lazy(() => import('@/pages/map/mobile/MapDownload'));
const MobileVrVideo = lazy(() => import('@/pages/map/mobile/VrVideo'));
const MobileBannerLayout = lazy(() => import('@/pages/map/mobile/Banner'));

const mobileMapRoutes: RouteObject[] = [
  {
    path: '/map',
    element: (
      <AppInitializerGuard>
        <MobileMapLayout />
      </AppInitializerGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="search" replace />
      },
      {
        path: 'search',
        element: <MobileSearchLayout />
      },
      // {
      //   path: 'land-info',
      //   element: <MobileLandInfoLayout />
      // },
      {
        path: 'life',
        element: <MobileLifeContentsLayout />
      },
      {
        path: 'culture',
        element: <MobileCultureContentsLayout />
      },
      {
        path: 'safe',
        element: <MobileSafeContentsLayout />
      },
      {
        path: 'wanted',
        element: <MobileWantedLayout />
      },
      {
        path: 'vr',
        element: <MobileVrVideo />
      },
      {
        path: 'campaign',
        element: <MobileCampaignMap />
      },
      {
        path: 'construct',
        element: <MobileConstructionNotification />
      },
      {
        path: 'slider',
        element: <MobileAirmapSliderLayout />
      },
      {
        path: 'statistic',
        element: <MobileStatisticMap />
      },
      {
        path: 'download',
        element: <MobileMapDownloadLayout />
      },
      {
        path: 'banner',
        element: <MobileBannerLayout />
      }
    ]
  }
];

export default mobileMapRoutes;
